import { get } from "lodash-es";
import { getSourceProtocolBySource } from "../../../utils/protocol";
export function getCodeAndMsg(instance, body, params) {
  const {
    codeKey,
    msgKey
  } = params;
  const protocol = getSourceProtocolBySource(instance);
  const code = codeKey || protocol.CODE;
  const message = msgKey || protocol.MESSAGE;
  return {
    code: get(body, code),
    message: get(body, message)
  };
}
export function getCgiCodeMsg(ctx, body) {
  const code = get(body, ctx.protocol.CODE);
  const message = get(body, ctx.protocol.MESSAGE);
  return {
    code,
    message
  };
}
//# sourceMappingURL=getCodeAndMsg.js.map
